import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { getLocalUserId } from 'src/features/auth';
import { useGetUser } from 'src/features/profile/api/useGetUser';
import ProfileLayout from 'src/features/profile/components/ProfileLayout';
import ProfilePasswordForm from 'src/features/profile/components/ProfilePasswordForm';
import { passwordMessages } from 'src/features/profile/utils';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import {
    SectionBlock,
    SectionBlockHeader,
    SectionBlockHead,
    SectionBlockTitle,
    SectionBlockSubtitle,
    SectionBlockSeparator,
    SectionBlockBody,
} from 'src/registry/components/blocks/SectionBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';

const Password = () => {
    const { formatMessage } = useIntl();
    const userId = getLocalUserId();
    const { data, isLoading, isError } = useGetUser({ userId, config: { enabled: !!userId } });

    return (
        <ProfileLayout>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(passwordMessages.passwordTitle)}</SectionBlockTitle>
                        <SectionBlockSubtitle>{formatMessage(passwordMessages.passwordSubtitle)}</SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody>
                    {isLoading && (
                        <div>
                            <Skeleton className="mt-4 h-12 w-full" />
                            <Skeleton className="mt-4 h-12 w-full" />
                            <Skeleton className="mt-4 h-12 w-full" />
                        </div>
                    )}
                    {isError && <GeneralMessageBlock variant="error" icon={faCircleExclamation} />}
                    {data && <ProfilePasswordForm user={data} />}
                </SectionBlockBody>
            </SectionBlock>
        </ProfileLayout>
    );
};

export default Password;
